{
  "title": "Оплата",
  "description": "Підписка школи, місця та рахунки.",
  "loadFailed": "Не вдалося завантажити дані про оплату.",
  "disabled": {
    "title": "Оплату не налаштовано",
    "description": "Ця інсталяція працює без платіжного провайдера, тож тут нічого налаштовувати й нічого сплачувати. Школа має повний доступ."
  },
  "status": {
    "label": "Стан",
    "trialing": "Пробний період",
    "active": "Активна",
    "past_due": "Оплату прострочено",
    "canceled": "Скасована",
    "locked": "Доступ призупинено",
    "none": "Підписки немає"
  },
  "summary": {
    "title": "Підписка",
    "trialDaysLeft_one": "залишився {{count}} день",
    "trialDaysLeft_few": "залишилося {{count}} дні",
    "trialDaysLeft_many": "залишилося {{count}} днів",
    "trialDaysLeft_other": "залишилося {{count}} днів",
    "trialEndsToday": "завершується сьогодні",
    "trialEndsOn": "Пробний період завершується {{date}}.",
    "trialSoon": "Оберіть тариф до цієї дати, щоб зберегти доступ до даних школи.",
    "renewsOn": "Поновлення {{date}}",
    "endsOn": "Доступ діє до {{date}}",
    "planMonthly": "Щомісячний тариф",
    "planAnnual": "Річний тариф",
    "cancelAtPeriodEnd": "Підписку буде завершено {{date}}. Її можна поновити в платіжному кабінеті.",
    "pastDue": "Останній платіж не пройшов. Школа працює далі, поки банк повторює списання, — оновіть спосіб оплати в платіжному кабінеті.",
    "locked": "Доступ до школи призупинено до завершення оплати. Нічого не видалено.",
    "retention": "Дані школи зберігаються до {{date}}.",
    "noSubscription": "Ця школа ще не має підписки.",
    "contactAdmin": "Змінювати підписку може лише адміністратор школи. Зверніться до нього, якщо щось потрібно оновити."
  },
  "seats": {
    "title": "Місця",
    "count_one": "{{count}} вчительське місце",
    "count_few": "{{count}} вчительські місця",
    "count_many": "{{count}} вчительських місць",
    "count_other": "{{count}} вчительських місць",
    "explanation": "Місце займають адміністратори та вчителі. Учні й батьки — безкоштовно і без обмежень.",
    "manageMembers": "Керувати учасниками"
  },
  "price": {
    "title": "Скільки це коштує",
    "perSeatMonth": "{{amount}} за місце / місяць",
    "perSeatYear": "{{amount}} за місце / рік",
    "monthly": "Щомісяця",
    "annual": "Щороку",
    "totalPerMonth": "{{amount}} / місяць",
    "totalPerYear": "{{amount}} / рік",
    "listPrice": "Базова ціна — {{amount}} за місце на місяць.",
    "discountApplied": "Застосовано знижку за обсяг {{percent}}% — вона діє від {{minSeats}} місць.",
    "discountAt": "Школи від {{minSeats}} місць платять менше за кожне місце.",
    "annualSaving": "Економія {{amount}} на рік порівняно зі щомісячною оплатою.",
    "note": "Ціни розраховано на поточну кількість місць. Списання виконує Stripe за сумою в рахунку."
  },
  "actions": {
    "title": "Оберіть тариф",
    "interval": "Періодичність оплати",
    "subscribe": "Перейти до оплати",
    "subscribing": "Відкриваємо Stripe…",
    "manage": "Керувати оплатою",
    "managing": "Відкриваємо кабінет…",
    "manageNote": "Спосіб оплати, зміна тарифу та скасування — у платіжному кабінеті Stripe.",
    "stripeNote": "Оплата відбувається на боці Stripe. Osvitly не бачить даних вашої картки.",
    "failed": "Не вдалося відкрити сторінку оплати. Спробуйте ще раз."
  },
  "checkout": {
    "success": "Оплату отримано. Stripe підтвердить підписку за мить — щойно це станеться, тут з’явиться новий стан.",
    "canceled": "Оплату скасовано. Кошти не списано."
  },
  "invoices": {
    "title": "Рахунки",
    "number": "Рахунок",
    "date": "Дата",
    "amount": "Сума",
    "status": "Стан",
    "view": "Переглянути",
    "pdf": "PDF",
    "empty": "Рахунків ще немає.",
    "loadFailed": "Не вдалося завантажити рахунки.",
    "statuses": {
      "draft": "Чернетка",
      "open": "Не сплачено",
      "paid": "Сплачено",
      "void": "Анульовано",
      "uncollectible": "Безнадійний"
    }
  },
  "paused": {
    "title": "Доступ до школи призупинено",
    "heading": "Школу «{{school}}» призупинено",
    "description": "Підписка школи неактивна, тому застосунок доступний лише для читання, доки її не поновлять. Жодного уроку, оцінки чи файлу не видалено.",
    "retention": "Дані школи зберігаються до {{date}}.",
    "askAdmin": "Завершити оплату має адміністратор школи. Щойно він це зробить, усе повернеться.",
    "adminAction": "Перейти до оплати",
    "switchSchool": "Якщо ви належите до іншої школи, перемкніться на неї у списку шкіл угорі сторінки."
  },
  "dashboard": {
    "trialTitle": "Пробний період",
    "pastDueTitle": "Оплату прострочено",
    "trialBody_one": "Пробний період школи завершується через {{count}} день.",
    "trialBody_few": "Пробний період школи завершується через {{count}} дні.",
    "trialBody_many": "Пробний період школи завершується через {{count}} днів.",
    "trialBody_other": "Пробний період школи завершується через {{count}} днів.",
    "trialBodyToday": "Пробний період школи завершується сьогодні.",
    "pastDueBody": "Останній платіж не пройшов. Оновлення способу оплати збереже роботу школи.",
    "open": "Відкрити оплату"
  }
}
